import { useQuery } from "@tanstack/react-query";

import { getRdo } from "@/adapters/api";
import type { Rdo } from "../types.ts";
import { toRdo } from "../utils/map.ts";

export function rdoQueryKey(
	constructionId: string | undefined,
	rdoId: string | undefined,
) {
	return ["rdo", constructionId, rdoId] as const;
}

export function useRdo(
	constructionId: string | undefined,
	rdoId: string | undefined,
) {
	return useQuery({
		queryKey: rdoQueryKey(constructionId, rdoId),
		queryFn: async (): Promise<Rdo> => {
			// biome-ignore lint/style/noNonNullAssertion: guarded by `enabled`
			const rdo = await getRdo(constructionId!, rdoId!);
			return toRdo(rdo);
		},
		enabled: !!constructionId && !!rdoId,
		staleTime: 10_000,
		refetchInterval: (query) =>
			query.state.data?.status === "generating" ? 3_000 : false,
	});
}
